module.exports = __webpack_public_path__ + "img/AddSite.066eacd6.png";